module.exports = __webpack_public_path__ + "img/mana2.7ffd81c8.png";